import { createContext } from 'react';

const MustHavesContext = createContext();

export default MustHavesContext;
